"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormControl.default;
  }
});

var _FormControl = _interopRequireDefault(require("./FormControl"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/FormControl/index.js
 ** module id = 376
 ** module chunks = 0
 **/